// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import ThemeEffects from './ThemeEffects';
import HeliosHeader from './HeliosHeader';
import IconRail from './IconRail';
import ContextualSubnav from './ContextualSubnav';
import AskHeliosPanel from './AskHeliosPanel';
import AppRoutes from './AppRoutes';
import SessionExpiredModal from '../common/SessionExpiredModal';
import ProfileLoadWarning from '../common/ProfileLoadWarning';
import HeliosFooter from './HeliosFooter';
import './shell.css';

/**
 * The Carbon-based Helios shell. Replaces the old top-bar + chat/dashboard
 * layout. When unauthenticated we render the routes bare (so /login shows);
 * once authenticated the full rail + subnav + main chrome renders.
 */
export default function AppShell() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <ThemeEffects>
      {!isAuthenticated ? (
        <div className="helios-shell">
          <main className="helios-main">
            <AppRoutes />
            <HeliosFooter />
          </main>
        </div>
      ) : (
        <div className="helios-shell">
          <HeliosHeader />
          <SessionExpiredModal />
          <ProfileLoadWarning />
          <div className="helios-body">
            <IconRail />
            <ContextualSubnav />
            <main className="helios-main">
              <AppRoutes />
              <HeliosFooter />
            </main>
          </div>
          <AskHeliosPanel />
        </div>
      )}
    </ThemeEffects>
  );
}
